import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeadersService } from './http-headers.service';
import { Urls } from '../utilities/urls.component';

@Injectable()
export class TwofactorAuthenticationService {

  constructor(private http: HttpClient, private headers: HttpHeadersService) { }
  // all 2fa flags and status data
  public getUser2FAStatus(userEmail: string) {
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.getUser2FASatus+userEmail;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

  // QR code
  public getQRCode(id: string) {
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.getQRCode+id;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

  // enable 2fa for user
  public enableUser2FA(id:string,validationCode:string) {
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.enableUser2FA+"?id="+id+"&validationCode="+validationCode;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

  // disable 2fa for user
  public disableUser2FA(id:string){
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.trunOff2FA+"?id="+id;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

  // validate 6 digit code
  public validateUser(id:string,validationCode:string){
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.validateUser+"?id="+id+"&validationCode="+validationCode;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

  // update first time login flag
  public updateFirstTimeLogin(id:string,flag:boolean){
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.getFirstTimeLogin+"?id="+id+"&flagValue="+flag;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

  // enable/disable team 2fa for partner admin
  public teamOnOff(orgName:string,flag:boolean){
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.team2FAOnOff+"?orgName="+orgName+"&flagValue="+flag;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

    // enable/disable team 2fa for system admin
  public teamOnOffForSystemAdmin(flag:boolean){
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.team2FAOnOffForAdmin+"?flagValue="+flag;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

  // reset 2fa
  public reset2FA(userEmail: string) {
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.reset2FA+userEmail;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  // reset link 
  public reset2FAlink(link:string) {
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.reset2FAlink+"?link="+link;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

  // disable user by admin
  public disableUser2FAByAdmin(id: string) {
    var url: string = Urls.API_ENDPOINT + Urls.FAauthentication.disable2FA+"?user_id="+id;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

}